import { NodeStore, StoreType } from "./NodeStore";

/**
 * This class represents a website node that displays a website from a given URL.
 * It extends the NodeStore class by adding properties specific to website nodes 
 * while also reusing shared behavior such as positioning and sizing.
 */
export interface WebNodeArgs {
    x: number;
    y: number;
    url: string;
}

/**
 * This method is the constructor for an WebNodeStore and initializes its 
 * positioning and website source. It sets default dimensions if none are provided.
 * @param args The Object containing the x and y coordinates, website URL.
 */
export class WebNodeStore extends NodeStore {
    public url: string;

    constructor(args: WebNodeArgs) {
        super();
        this.type = StoreType.Web;
        this.x = args.x;
        this.y = args.y;
        this.url = args.url;
    }
}